// Mock-mode switch and the pre-authenticated session it boots into.
//
// Mocks are on for the web build only, so the iOS/Android apps keep talking to
// the real API. Flip USE_MOCK_API to force it either way.

import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";
import {
	MOCK_REFRESH_TOKEN,
	MOCK_SUB_USER,
	MOCK_TOKEN,
	MOCK_USER_INFO,
} from "./fixtures";

export const USE_MOCK_API = Platform.OS === "web";

export { default as mockAdapter } from "./adapter";
export * from "./fixtures";

/**
 * Redux preloaded state that lands the app straight in the signed-in
 * experience. RootStack gates on `auth.auth && auth.subUser`, so seeding both
 * here means the boarding stack never renders — no splash/login flash.
 */
export const mockPreloadedState = {
	auth: {
		email: MOCK_USER_INFO.email,
		userInfo: MOCK_USER_INFO,
		token: MOCK_TOKEN,
		refreshToken: MOCK_REFRESH_TOKEN,
		auth: true,
		subUser: MOCK_SUB_USER,
	},
	discounts: [],
	announcements: [],
} as any;

/**
 * Mirror the session into AsyncStorage (localStorage on web). The request
 * interceptor in store/api.ts reads the token from there, and Settings reads
 * the saved-user keys.
 */
export const seedMockStorage = async (): Promise<void> => {
	try {
		await AsyncStorage.multiSet([
			["@userToken", MOCK_TOKEN],
			["@refreshUserToken", MOCK_REFRESH_TOKEN],
			["@userInfo", JSON.stringify(MOCK_USER_INFO)],
			["@activeUserId", MOCK_SUB_USER.id],
			["@allUserInfo", JSON.stringify([MOCK_SUB_USER])],
		]);
	} catch (e) {
		console.warn("[mock] could not seed session storage", e);
	}
};
